module.exports = __webpack_public_path__ + "static/media/ph.71128d4e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ph.svg
// module id = 2187
// module chunks = 0